<template>
  <div class="content-container">
    <div class="grid-scroll">
      <GridEnterprise
        ref="agGrid"
        :columns="columnDefs"
        dom-layout="scroll"
        :rows="rowData"
        class="agGrid"
      />
    </div>
    <div class="button-containers">
      <button class="btn primary small" @click="onConfiguration">
        Cấu hình
      </button>
    </div>
    <el-dialog
      :title="$t('dialog.configPaymentMethod')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <el-tabs
        v-model="tabIndex"
        tab-position="left"
        class="flex"
        @tab-click="onTabClick"
      >
        <el-tab-pane
          v-for="(item, index) in methodNames"
          :key="index"
          v-loading="configTabTableLoading"
          :label="item.nameDetail"
          class="flex-1"
        >
          <div
            v-for="(item2, index2) in configTabTableData"
            :key="index2"
            style="margin-bottom: 10px"
          >
            <div style="height: 250px" class="w-100">
              <GridVx
                ref="agGrid"
                :context="context"
                :columns="columns"
                dom-layout="scroll"
                :auto-size-cell="true"
                :row-multi-select-with-click="true"
                :rows="item2.transaction_list"
                class="agGrid"
                @doubleClicked="onDoubleClicked"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button class="btn primary small" @click="updatePopupContent">
            {{ $t('button.update') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderCheckbox } from '@/utils/cellRenders.js'
import {
  getListApi,
  getListMethodName
} from '@/api/configuration/accounting/deposit/hotel.js'
export default {
  props: {
    searchParams: {
      type: Object,
      default: () => {}
    },
    configNameList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox
  },
  data() {
    return {
      configTabTableData: null,
      configTabTableLoading: false,
      tabIndex: '0',
      tab: 0,
      context: null,
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      // defaultColDef: null,
      // autoGroupColumnDef: null,
      // modules: [
      //   ClientSideRowModelModule,
      //   RowGroupingModule,
      //   MenuModule,
      //   ColumnsToolPanelModule,
      //   SetFilterModule
      // ],
      rowData: null,
      //
      // searchParams: {
      //   type: 1
      // },
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      buildingItem: {
        building_no: '',
        name: '',
        id: null
      },
      columns: [
        {
          headerName: 'Chọn',
          field: 'active',
          cellRenderer: 'CellRenderCheckbox',
          maxWidth: 80
        },
        {
          headerName: 'Giao dịch',
          field: 'transaction_nm',
          tooltipField: 'transaction_nm',
          maxWidth: 150
        },
        {
          headerName: 'Giao dịch phụ',
          field: 'sub_transaction_nm',
          tooltipField: 'sub_transaction_nm',
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'sub_transaction_desc',
          tooltipField: 'sub_transaction_desc',
          minWidth: 200
        }
      ],
      rows: [],
      methodNames: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
    this.gridOptions = {}
    this.columnDefs = [
      {
        field: 'method_nm',
        valueGetter: param => {
          let output = null
          switch (param.data.method_nm) {
            case this.configNameList[0]:
              output = 'Tiền mặt'
              break
            case this.configNameList[1]:
              output = 'Khác'
              break
            case this.configNameList[2]:
              output = 'Thẻ tín dụng'
              break
            case this.configNameList[3]:
              output = 'Chuyển khoản'
              break
            case this.configNameList[4]:
              output = 'Công nợ'
              break
            case this.configNameList[5]:
              output = 'Thẻ trả trước'
              break
            default:
              break
          }
          return output
        },
        cellClass: 'grid-cell-centered',
        minWidth: 300,
        rowGroup: true,
        hide: true
      },
      // {
      //   field: 'c_method_nm',
      //   cellClass: 'grid-cell-centered',
      //   rowGroup: true,
      //   maxWidth: 100,
      //   hide: true
      // },
      {
        headerName: 'Giao dịch',
        headerClass: 'header-cell-center',
        cellClass: 'grid-cell-centered',
        field: 'c_transaction_nm',
        tooltipField: 'c_transaction_nm',
        maxWidth: 200
      },
      {
        headerName: 'Giao dịch phụ',
        headerClass: 'header-cell-center',
        cellClass: 'grid-cell-centered',
        field: 'c_sub_transaction_nm',
        tooltipField: 'c_sub_transaction_nm',
        maxWidth: 200
      },
      {
        headerName: 'Mô tả',
        // headerClass: 'header-cell-center',
        // cellClass: 'grid-cell-centered',
        field: 'c_sub_transaction_desc',
        tooltipField: 'c_sub_transaction_desc',
        // minWidth: 200
        flex: 1
      }
    ]
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
    this.attachData()
    // this.getPopupRow()
  },
  methods: {
    async onConfiguration() {
      if (this.methodNames.length > 0) {
        await this.getPopupRow(this.methodNames[0].method_id)
        this.dialogFormVisible = true
        setTimeout(() => {
          this.$store.dispatch('mci/changeTab', {
            value: -1
          })
        }, 200)
      }
    },
    async updatePopupContent() {
      const data = {
        transaction_config_update_form: this.configTabTableData
      }
      bus.$emit('startLoader', { msg: '' })
      this.$axios
        .put('/config-service/v1/account/transaction-config', data)
        .then(async res => {
          await this.attachData()
          this.dialogFormVisible = false
          bus.$emit('endLoader')
          this.$message({
            type: 'success',
            message: 'Cập nhật thành công'
          })
        })
    },
    getPopupRow(id) {
      this.configTabTableLoading = true
      this.$axios
        .get(
          `/config-service/v1/account/transaction-config/transaction?type=${this.searchParams.type}&methodId=${id}`
        )
        .then(res => {
          this.rows = res.data[0].transaction_list
          this.configTabTableData = res.data
          this.configTabTableLoading = false
        })
    },
    changeCheckbox(colNm, params) {
      let active
      const index = params.rowIndex
      this.rows[index].active ? (active = false) : (active = true)
      this.rows[index].active = active
    },
    onTabClick(params) {
      this.tab = params.index
      const id = this.methodNames[this.tab].method_id
      this.getPopupRow(id)
      this.$store.dispatch('mci/changeTab', {
        value: this.tab
      })
    },
    async attachData() {
      let data = await getListApi(this.searchParams)
      this.rowData = data.data
      const data1 = await getListMethodName(this.searchParams)
      this.methodNames = data1.data.map(item => {
        return {
          ...item,
          nameDetail: this.$t(`variables.${item.method_nm}`)
        }
      })
      // this.rowData.map(item => {
      //   if (item.method_nm) {
      //     let a = true
      //     this.methodNames.forEach(b => {
      //       if (b.name == item.method_nm) {
      //         a = false
      //       }
      //     })
      //     if (a) {
      //       this.methodNames.push({
      //         id: item.method_id,
      //         name: item.method_nm,
      //         nameDetail: this.$t(`variables.${item.method_nm}`)
      //       })
      //     }
      //   } else {
      //     let a = true
      //     this.methodNames.forEach(b => {
      //       if (b.name == item.c_method_nm) {
      //         a = false
      //       }
      //     })
      //     if (this.methodNames.indexOf(item) == -1) {
      //       if (a) {
      //         this.methodNames.push({
      //           id: item.c_method_id,
      //           name: item.c_method_nm,
      //           nameDetail: this.$t(`variables.${item.method_nm}`)
      //         })
      //       }
      //     }
      //   }
      // })
    },
    async addBuilding() {
      if (this.buildingItem.building_no == '' || this.buildingItem.name == '') {
        this.$alert('Bạn phải điền đủ các trường thông tin', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        let data = await addBuildingApi(this.buildingItem)
        this.dialogFormVisible = false
        this.$message({
          type: 'success',
          message: 'Bạn đã thêm toà nhà thành công'
        })
        this.attachData()
      }
    },
    async updateBuilding() {
      if (this.buildingItem.building_no == '' || this.buildingItem.name == '') {
        this.$alert('Bạn phải điền đủ các trường thông tin', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        let data = await updateBuildingApi(this.buildingItem)
        this.dialogFormVisible = false
        this.$message({
          type: 'success',
          message: 'Bạn đã cập nhật toà nhà thành công'
        })
        this.attachData()
      }
    },

    async deleteBuilding() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$alert('Bạn chưa chọn toà nhà!', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        this.$confirm('Bạn chắc chắn muốn xoá toà nhà này?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          deleteBuildingApi({
            id_list: id_list
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: 'Bạn đã xoá toà nhà thành công'
              })
              this.attachData()
            })
            .catch(() => {
              this.dialogFormVisible = false
            })
        })
      }
    },

    onDoubleClicked(rows) {
      this.titlePopup = 'Sửa toà nhà'
      this.isEdit = true
      const rowData = rows[0]
      this.buildingItem.building_no = rowData.building_no
      this.buildingItem.name = rowData.name
      this.buildingItem.id = rowData.id
      this.dialogFormVisible = true
    },
    resetInfo() {
      this.tabIndex = '0'
    }
  }
}
</script>

<style lang="scss" scoped></style>
